import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })

export class PageService {
  constructor(private userService: UserService, private keycloakService: KeycloakService, private router: Router) { }

  async loadPage(partner, account, url) {

    const user = await this.keycloakService.loadUserProfile(true);

    if (user['attributes'].partnerMerchantKeys)
      var merchant = user['attributes'].partnerMerchantKeys ? user['attributes'].partnerMerchantKeys[0] : null;

    if (!account && (await this.keycloakService.isLoggedIn())) {

      account =
        user['attributes'].partnerAccountKeys[0].split('##')[0];

      if (merchant)
        this.router.navigate([partner, account, merchant, 'transactions']);
      else {
        if (this.keycloakService.getKeycloakInstance().realm != 'tuna') {
          this.router.navigate([partner, account]);
        } else {
          this.router.navigate([partner, account, 'partners']);
        }
      }
    }

    if (user['attributes'].partnerMerchantKeys) {
      const merchants = user['attributes'].partnerMerchantKeys as any;
      const split = url.split('/', 4);

      if (split)
        if (split[3]) {  //precisa ter na url o merchant quando for usuário merchant
          if (merchant) {
            if (!merchants.find(p => p == split[3]))
              return 'not_found';
            else {
              return 'console';
            }
          }

        }

    } else {

      var split = url.split('/');
      if (split.length >= 4) {

        var splitParm = split[3].split('?');

        let obj = this.userService.getUser().features.find(p => p.configs.url == splitParm[0]);
        if (obj) {
          if (!obj.enabled) {
            return 'error';
          } else {
            return 'console';
          }
        } else {
          return 'not_found';
        }
      }
    }

  }


  async canLoadPage(partner, account, url, user) {
    var merchants = user['attributes'].partnerMerchantKeys ? user['attributes'].partnerMerchantKeys : null;
    if (merchants) {

      const split = url.split('/');

      if (split) {
        if (split.length >= 4) {  //precisa ter na url o merchant quando for usuário merchant -  // /montevero/monte_vero_sp/Goomer-1234
          if (merchants) {
            if (merchants.find(p => p == split[3]))
              return true;
            else {
              return false;
            }
          }
        } else {
          if (split.length == 3 && await this.keycloakService.isLoggedIn()) { // /montevero/monte_vero_sp/
            this.router.navigate([partner, account, merchants[0], 'transactions']);
          }

          return false;
        }
      }

    } else {


      var split = url.split('/');

      if (split.length >= 4) {
        let obj = await this.userService.getUser().features.find(p => p.configs.url == split[3]);
        if (obj) {
          if (!obj.enabled) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        if (await this.keycloakService.isLoggedIn()) { // /montevero/monte_vero_sp/
          if (partner == 'tuna') {
            this.router.navigate([partner, account, 'tuna', 'transactions']);

          } else {
            this.router.navigate([partner, account, 'transactions']);
          }
        } else {
          this.keycloakService.logout();
          this.router.navigate(['']);
        }
      }
    }
  }
}
